
import * as R from 'ramda'

/**
 * title 更改body的title
 */
export function title(title) {
    title = title ? title : this.defaultTitle
    window.document.title = title 
}

/**
 * param 判断是否为空
 */
export function isEmpty(param){
    return R.isEmpty(param)||R.isNil(param);
}

/**
 * str 过滤两边空格
 */
export function Trim(str){
    return R.trim(str);
}

/**
 * 是否是手机号
 * @param { } str 
 */
export function isMobile (str) {
    var myreg = /^1(1|2|3|4|5|6|7|8|9)\d{9}$/;
    if (!myreg.test(str)) {
        return false;
    } else {
        return true;
    }
}

/**
 *  是否是正确的邮箱
 * @param {*} strEmail 
 */
export function isEmail (strEmail) {
    var pattern = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
    return pattern.test(strEmail);
}

/**
 * 判断是否是数字
 */
export function  isNum(str){
    var reg = /(^[1-9]{1}\d*$)|(^[1-9]{1}\d*\.{1}\d{1,2}[0]*$)|(^[0]{1}\.{1}\d{0,1}[1-9]{1}[0]*$)/;
    if(!reg.test(str)){
        return false;
    }else{
        return true;
    }

}

export default {
  defaultTitle: '汽车时间',
  title,
  isEmpty,
  Trim,
  isMobile,
  isEmail,
  isNum
}
